import { format } from 'date-fns'
//import { ColumnFilter } from './../../Shipment/ColumnFilter'
import { ColumnFilter } from '../../Shipment/ColumnFilter'
export const COLUMNS = [
  {
    Header: 'Digit',
    accessor: 'digitId',
    disableFilters: true,
    sticky: 'left',
    Filter: ColumnFilter,
  },
  {
    Header: 'Brand',
    accessor: 'brand',
    sticky: 'left',
    Filter: ColumnFilter,
  },
  {
    Header: 'Model',
    accessor: 'model',
    Filter: ColumnFilter,

  },
  {
    Header: 'Refrence No',
    accessor: 'refno',
    Filter: ColumnFilter,

  },
  {
    Header: 'Description',
    accessor: 'description',
    Filter: ColumnFilter,
  },
  // {
  //   Header: 'movement',
  //   accessor: 'movement',
  //   Filter: ColumnFilter,
  // },
  //{
  //  Header: 'Gender',
   // accessor: 'gender',
    //sticky: 'left',
    //Filter: ColumnFilter,
  //},
  {
    Header: 'Status',
    accessor: 'status',
    disableFilters: true,
    Filter: ColumnFilter,
  },
  {
    Header: 'Price',
    accessor: 'salesPrice',
    disableFilters: true,
    Filter: ColumnFilter,
  },
  {
    Header: 'Min Price',
    accessor: 'minPrice',
    disableFilters: true,
    Filter: ColumnFilter,
  },
 // {
   // Header: 'Caliber',
    //accessor: 'caliber',
    //Filter: ColumnFilter,
  //},
  {
    Header: 'Photo',
    accessor: 'photos',
    disableFilters: true,
    Filter: ColumnFilter,
    disableSortBy: true
  },
]